/*
 * KETTLER: Sofortige Rückmeldung beim Hinzufügen zum Warenkorb (Louis/Christoph 06.10.2026).
 *
 * Horizon öffnet die Warenkorb-Lade und zählt die Zahl am Warenkorb erst hoch, wenn
 * zwei Anfragen nacheinander zurück sind (cart/add, dann cart.js): 0,6–1 s ohne Reaktion.
 * Dieses Skript reagiert schon beim Absenden: Zahl sofort hochzählen und pulsieren lassen,
 * Lade sofort öffnen und einen Ladebalken zeigen. Kommt Horizons cart:update, übernimmt
 * es die echten Daten; die Zahl stimmt dann bereits, Horizon zählt intern selbst weiter.
 * Kommt nichts (z. B. Höchstmenge erreicht), wird die Zahl nach kurzer Zeit aus cart.js korrigiert.
 */
(function () {
  var NOTBREMSE = 6000;
  var aktiv = false;
  var timer = null;

  function lade() { return document.querySelector('cart-drawer-component'); }
  function icons() { return Array.prototype.slice.call(document.querySelectorAll('cart-icon')); }

  function pulsieren(icon) {
    icon.classList.remove('k-cart-pop');
    void icon.offsetWidth;
    icon.classList.add('k-cart-pop', 'k-cart-sofort');
    setTimeout(function () { icon.classList.remove('k-cart-pop'); }, 700);
  }

  function zahlSetzen(fn) {
    icons().forEach(function (icon) {
      var zahl = icon.querySelector('[ref="cartBubbleCount"]');
      var blase = icon.querySelector('[ref="cartBubble"]');
      if (!zahl || !blase) return;
      var neu = fn(parseInt(zahl.textContent, 10) || 0);
      zahl.textContent = String(neu);
      zahl.classList.toggle('hidden', neu === 0);
      blase.classList.toggle('visually-hidden', neu === 0);
      icon.classList.toggle('header-actions__cart-icon--has-cart', neu > 0);
    });
  }

  function start(menge) {
    aktiv = true;
    zahlSetzen(function (alt) { return alt + menge; });
    icons().forEach(pulsieren);

    var l = lade();
    if (l && l.hasAttribute('auto-open') && typeof l.showDialog === 'function') {
      l.classList.add('k-lade-laedt');
      var dialog = l.querySelector('dialog');
      if (dialog && !dialog.querySelector('.k-lade-hinweis')) {
        var hinweis = document.createElement('div');
        hinweis.className = 'k-lade-hinweis';
        hinweis.setAttribute('aria-hidden', 'true');
        hinweis.innerHTML = '<span class="k-lade-hinweis__punkt"></span><span class="k-lade-hinweis__punkt"></span><span class="k-lade-hinweis__punkt"></span>';
        dialog.appendChild(hinweis);
      }
      l.showDialog();
    }

    clearTimeout(timer);
    timer = setTimeout(function () { ende(true); }, NOTBREMSE);
  }

  function ende(korrigieren) {
    aktiv = false;
    clearTimeout(timer);
    var l = lade();
    if (l) {
      l.classList.remove('k-lade-laedt');
      var h = l.querySelector('.k-lade-hinweis');
      if (h) h.remove();
    }
    setTimeout(function () {
      icons().forEach(function (icon) { icon.classList.remove('k-cart-sofort'); });
    }, 1200);
    if (!korrigieren) return;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      zahlSetzen(function () { return cart.item_count; });
    }).catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var komponente = form.closest('product-form-component');
    if (!komponente) return;
    var knopf = komponente.querySelector('[ref="addToCartButton"], button[type="submit"]');
    if (knopf && knopf.disabled) return;
    if (aktiv) return;
    var feld = form.querySelector('[name="quantity"]');
    var menge = Number(feld && feld.value) || Number(komponente.dataset.quantityDefault) || 1;
    start(menge);
  }, true);

  document.addEventListener('cart:update', function () { if (aktiv) ende(false); });
  document.addEventListener('cart:error', function () { if (aktiv) ende(true); });
})();
